import { AuthenticationFunctions } from "@/commons/AuthenticationFunctions.ts";

export const onHandleGetEnvironmentLocalStorage = (): boolean => {
  return process.env.NODE_ENV === "development";
};

export const onHandleGetTenantId = (): string => {
  const primaryTenantId = AuthenticationFunctions.getTokenDataByKey("tenantId");
  let tenantId = primaryTenantId;
  if (window.tenantId) {
    tenantId = window.tenantId;
  }
  // if (process.env.NODE_ENV === "development") {
  //   const routing = window.location.pathname.split("/");
  //   tenantId = routing[1] ?? TenantEnum.ROOT;
  // }
  return tenantId;
};

export const nameAttribute = "data-rc-id";

interface IBuildRCAttribute {
  [nameAttribute]: string;
}

export const BuildRCAttribute = (value: string): IBuildRCAttribute => {
  return { [nameAttribute]: value };
};
